import React from 'react';
import Icon from '../../components/Icon';
import { manager30Url } from '../url';

export default [
  {
    name: '运营中心',
    initials: '运营',
    icon: <Icon type="pangu-yunyingzhongxin" />,
    path: '/operateCenter',
    key: '/operateCenter',
    index: 0,
  },
  {
    name: '会员管理中心',
    initials: '会员',
    icon: <Icon type="pangu-huiyuanzhongxin" />,
    path: '/userCenter',
    key: '/userCenter',
    index: 1,
  },
  {
    name: '订单管理中心',
    initials: '订单',
    icon: <Icon type="pangu-dingdanzhongxin" />,
    path: '/module/order/',
    key: '/module/order/',
    index: 2,
  },
  {
    name: '交易中心',
    initials: '交易',
    icon: <Icon type="pangu-jiaoyi" />,
    path: '/module/trading/',
    key: '/module/trading/',
    index: 3,
  },
  {
    name: '财务中台',
    initials: '财务',
    icon: <Icon type="pangu-caiwu" />,
    path: '/financeCenter',
    key: '/financeCenter',
    index: 4,
  },
  {
    name: '数据中心',
    initials: '数据',
    icon: <Icon type="pangu-shujukanban" />,
    path: '/module/intelligent/',
    key: '/module/intelligent/',
    index: 5,
  },
  // {
  //   name: '供应商管理',
  //   initials: '供应商',
  //   icon: <Icon type="pangu-shujukanban" />,
  //   path: '/module/operateSupplier/',
  //   key: '/module/operateSupplier/',
  //   index: 6,
  // },
  // {
  //   name: '新礼商',
  //   initials: '新礼商',
  //   icon: <Icon type="pangu-linshigongzuo" />,
  //   path: '/home/application/socialCard/',
  //   key: '/home/application/socialCard/',
  //   index: 7,
  // },
  // {
  //   name: '素材管理',
  //   initials: '素材',
  //   icon: <Icon type="pangu-sucai" />,
  //   path: '/home/application/material/',
  //   key: '/home/application/material/',
  //   index: 8,
  // },
  // {
  //   name: '商机运营',
  //   initials: '商机',
  //   icon: <Icon type="pangu-wodeshangjizhuanhuan" />,
  //   path: '/home/application/business/',
  //   key: '/home/application/business/',
  //   index: 6,
  // },
  {
    name: '内容管理中心',
    initials: '内容',
    icon: <Icon type="pangu-fanhuijiuban" />,
    path: '/module/cms/',
    key: '/module/cms/',
    index: 6,
  },
  {
    name: '技术专用频道',
    initials: '技术',
    icon: <Icon type="pangu-linshigongzuo" />,
    path: '/temporaryCenter',
    key: '/temporaryCenter',
    index: 7,
  }
]